import { render, staticRenderFns } from "./OrganizationPacketSwitch.vue?vue&type=template&id=43050a57&"
import script from "./OrganizationPacketSwitch.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPacketSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports